type ErrorDefinition = {
  name: string
  displayValue: string
}

export const CREATE_PROPOSAL_ERRORS = {
  details: {
    title: {
      maxLengthError: (maxLength: number): ErrorDefinition => ({
        name: "createProposalMaxTitleLength",
        displayValue: `Title can have a max length of ${maxLength} characters`,
      }),
      required: (): ErrorDefinition => ({
        name: "createProposalTitleRequired",
        displayValue: "Title is required",
      }),
    },
    description: {
      required: (): ErrorDefinition => ({
        name: "createProposalDescriptionRequired",
        displayValue: "Description is required",
      }),
    },
  },
  actions: {
    selectedAbiMethod: {
      requiredInputs: (): ErrorDefinition => ({
        name: "createProposalSelectedAbiMethodInputRequired",
        displayValue: "Value is required",
      }),
    },
    target: {
      externallyOwnedAddress: (): ErrorDefinition => ({
        name: "createProposalTargetAddressIsEoa",
        displayValue:
          "Unable to retrieve the contract ABI from Etherscan. Please try to upload an ABI file instead.",
      }),
      invalidAddressError: (): ErrorDefinition => ({
        name: "createProposalTargetAddressInvalid",
        displayValue: "Must be a valid ETH address",
      }),
      required: (): ErrorDefinition => ({
        name: "createProposalTargetAddressRequired",
        displayValue: "Target address is required",
      }),
      unverified: (): ErrorDefinition => ({
        name: "createProposalTargetAddressUnverified",
        displayValue:
          "Contract not verified on Etherscan. Import ABI or enable sending ETH to EOA.",
      }),
    },
    method: {
      invalidArgs: (): ErrorDefinition => ({
        name: "createProposalMethodInvalidArgs",
        displayValue: "Value does not match argument type",
      }),
    },
    value: {
      positive: (): ErrorDefinition => ({
        name: "createProposalValueType",
        displayValue: "Value should be a positive number",
      }),
      required: (): ErrorDefinition => ({
        name: "createProposalValueRequired",
        displayValue: "Value is required",
      }),
      type: (): ErrorDefinition => ({
        name: "createProposalValueType",
        displayValue: "Value should be a number",
      }),
    },
    memo: {
      maxLengthError: (maxLength: number): ErrorDefinition => ({
        name: "createProposalMaxTransferMemoLength",
        displayValue: `Memo can have a max length of ${maxLength} characters`,
      }),
    },
    addedMember: {
      invalidAddressError: (): ErrorDefinition => ({
        name: "createProposaladdedAddressInvalid",
        displayValue: "Must be a valid address",
      }),
      duplicateAddressError: (): ErrorDefinition => ({
        name: "createProposaladdedAddressDuplicate",
        displayValue: "Cannot be a duplicate address",
      }),
    },
  },
  submit: (): ErrorDefinition => ({
    name: "createProposalSubmitError",
    displayValue:
      "An error occurred creating your proposal. In many cases, this error occurs when you have not met the required voting power.",
  }),
}
